<template>
  <v-sheet class="text-center d-flex flex-column align-center bg-background text-on-surface-variant">
    <span class="title font-weight-bold mb-3 mt-2">Coberturas e Exclusões</span>
    <span class="subtitle-2 text-center mb-4">Em complemento à cláusula 1.1.1 dos riscos cobertos nas
      <a
        href="https://cdn.bikehero.com.br/plans-conditions/condicoes-gerais-riscos-diversos-equipamentos-vigencia-atual.pdf"
        target="_blank"
      >condições gerais</a>,
      fica entendido e acordado que a bicicleta enquadra-se como um objeto portátil.
      Para o evento roubo/furto qualificado, além das situações previstas na condição geral as
      situações abaixo também terão amparo por esta garantia:
    </span>
    <span class="font-weight-bold subtitle-2 my-6">Coberturas do Plano Básico</span>
    <a
      class="subtitle-2 text-center mb-5"
      href="https://cdn.bikehero.com.br/plans-conditions/condicoes-particulares-plano-basico-v11-2024.pdf"
      target="_blank"
    >
      Condições Particulares
    </a>
    <span>Assalto enquanto pedala, incluindo competições em todo o território nacional.</span>
    <v-divider class="my-4" width="40%" />
    <span>Assalto da bicicleta enquanto transportada em veículo de passeio acompanhado do segurado e alocada em rack para uso específico e
      devidamente presa à bicicleta com trava, ou em transporte terrestre por empresa especializada contratada para esta finalidade
      e mediante contrato, ou por empresa de transporte aéreo.</span>
    <v-divider class="my-4" width="40%" />
    <span>Subtração dentro da residência habitual ou temporária com evidências de arrombamento.</span>
    <v-divider class="my-4" width="40%" />
    <span>Subtração fora da residência, desde que a bicicleta esteja presa pelo quadro a objeto irremovível por cadeado ou trava apropriada, mediante a vestígios de rompimentos de obstáculos e de preferência sob vigilância.</span>
    <v-divider class="my-4" width="40%" />
    <span>Subtração no interior de veículo, desde que estacionado em local e horário com circulação pessoas ou sob vigilância,
      estando o veículo com todos os dispositivos de segurança e alarme veicular em pleno funcionamento e devidamente ativados,
      bem como com os vidros totalmente fechados e com evidências de arrombamento do veículo.
      Não estará amparada nesta cobertura a subtração da bicicleta enquanto veículo pernoita,
      independentemente do local onde o veículo estiver estacionado.</span>

    <span class="font-weight-bold subtitle-2 my-6">Principais exclusões do Plano Básico</span>

    <span>Perda ou dano causado por desprendimento de rack durante o transporte.</span>
    <v-divider class="my-4" width="40%" />
    <span>Subtração da bike sem a ruptura de obstáculos ou cadeado ou trava apropriada.</span>
    <v-divider class="my-4" width="40%" />
    <span>Furto em ambientes externos como sacadas, varandas ou garagens, ainda que fechadas,
      desde que a bicicleta esteja devidamente presa pelo quadro a objeto irremovível com cadeado ou trava apropriada e com evidências de arrombamento.</span>
    <v-divider class="my-4" width="40%" />
    <span>Uso de chave falsa, escalada, apropriação indébita.</span>
    <v-divider class="my-4" width="40%" />
    <span>Furto em bicicletário com cadeados de cabo de aço.</span>
    <v-divider class="my-4" width="40%" />
    <span>Subtração enquanto utilizada por qualquer pessoa que não seja cônjuge, ascendentes ou descendentes do segurado.</span>
    <v-divider class="my-4" width="40%" />
    <span>Subtração por içamento ou por remoção do objeto ao qual a bicicleta estiver presa,
      sem que haja a necessidade de ruptura do cadeado ou trava apropriada.</span>
    <v-divider class="my-4" width="40%" />
    <span>Quaisquer danos de causa externa decorrentes do uso da bicicleta.</span>
    <v-divider class="my-4" width="40%" />
    <span>Furto parcial.</span>
    <v-divider class="my-4" width="40%" />
    <span>Furto da bicicleta se pernoitada em área aberta de livre acesso e/ou em via pública.</span>

    <span class="font-weight-bold subtitle-2 my-6">Coberturas do Plano Premium</span>
    <a
      class="subtitle-2 text-center mb-5"
      href="https://cdn.bikehero.com.br/plans-conditions/condicoes-particulares-plano-premium-v11-2024.pdf"
      target="_blank"
    >
      Condições Particulares
    </a>
    <span>Coberturas do plano básico</span>
    <v-divider class="my-4" width="40%" />
    <span>Dano acidental causado por impacto súbito da bicicleta durante a atividade de pedalar.</span>
    <v-divider class="my-4" width="40%" />
    <span>Dano na bike por colisão do veículo transportador.</span>
    <v-divider class="my-4" width="40%" />
    <span>Dano causado por tentativa de subtração, enquanto estacionada em bicicletário.</span>

    <span class="font-weight-bold subtitle-2 my-6">Principais exclusões do Plano Premium</span>

    <span>Exclusões do plano básico</span>
    <v-divider class="my-4" width="40%" />
    <span>Danos estéticos.</span>
    <v-divider class="my-4" width="40%" />
    <span>Danos não acidentais ou que estejam amparados pela garantia do fabricante.</span>
    <v-divider class="my-4" width="40%" />
    <span>Danos decorrentes de uso inadequado ou inapropriado da bicicleta ou por desgaste por uso.</span>
    <v-divider class="my-4" width="40%" />
    <span>Dano causado por desprendimento de rack durante o transporte.</span>
    <v-divider class="my-4" width="40%" />
    <span>Danos materiais ou imateriais causados a terceiros em razão da existência, uso e propriedade da bike.</span>
  </v-sheet>
</template>
<script>
</script>
<style scoped>
  span {
    font-weight: 300;
  }
</style>
